export default __webpack_public_path__ + "static/logo-947d2a86dcbeeb20201b7e9f46a87e4c.svg";